import { useTranslation } from '../hooks/useTranslation'
import { useShopLogo } from '../hooks/useShopLogo'
import type { Place } from '../types/display'
import ReviewCard from './ReviewCard'
import ShopLogo from './ShopLogo'

export default function BrandPanel({ placeId, place }: { placeId: string; place: Place | null }) {
  const { t } = useTranslation()
  const { src } = useShopLogo(placeId, place)

  return (
    <div className="relative flex h-full w-[38%] flex-col items-center justify-center overflow-hidden border-r-4 border-accent bg-panel px-[clamp(16px,2.5vw,32px)] pb-[clamp(60px,9vh,88px)] pt-[clamp(16px,3vh,32px)]">
      <div className="pointer-events-none absolute inset-0 bg-[repeating-linear-gradient(0deg,transparent,transparent_59px,rgba(0,0,0,0.02)_59px,rgba(0,0,0,0.02)_60px)]" />
      <div className="pointer-events-none absolute -bottom-[100px] -right-[100px] h-[300px] w-[300px] bg-[radial-gradient(circle,rgba(213,153,38,0.12)_0%,transparent_70%)]" />

      <div className="z-[1] flex w-full flex-col items-center">
        <ShopLogo src={src} />
        <div className="z-[1] mb-[clamp(8px,1.5vh,16px)] text-center font-volte text-[clamp(0.85rem,1.8vh,1.3rem)] italic text-text-mid">
          {t('welcome')}
        </div>
        {place?.google_place_id && <ReviewCard googlePlaceId={place.google_place_id} />}
      </div>

      <div className="absolute bottom-0 left-0 right-0 z-[2] flex items-center justify-between border-t border-divider bg-black/[0.03] px-[clamp(16px,2.5vw,28px)] py-[clamp(8px,1.5vh,16px)]">
        <img src="/images/logo-horizontal.svg" alt="Loving Loyalty" className="h-[clamp(24px,4vh,36px)] w-auto" />
        <div className="font-mono text-[clamp(0.65rem,1.3vh,0.9rem)] tracking-[0.06em] text-text-lo">
          llpos.dk
        </div>
      </div>
    </div>
  )
}
